import {
  DismissBannerMessageError,
  Mutation,
} from '@varo/graphql-schema-types';
import { useCallback, useMemo } from 'react';
import { DeleteSystemBannerMutation } from 'services/graphql/queries/FetchHomeTilesV2';
import { Maybe } from 'shared/utils/types';
import { useMutation } from 'urql';

interface DeleteSystemBannerContent {
  fetching: boolean;
  error: Maybe<string>;
  deleteBanner: (dismissID: string) => void;
}

const useDeleteSystemBanner = (): DeleteSystemBannerContent => {
  const [{ fetching, data, error: fetchError }, executeMutation] =
    useMutation<Mutation>(DeleteSystemBannerMutation);

  const deleteBanner = useCallback(
    (dismissID: string) => {
      void executeMutation({
        input: { id: dismissID },
      });
    },
    [executeMutation],
  );

  const dismissBannerMessage = data?.dismissBannerMessage;
  const error = useMemo<Maybe<string>>(() => {
    const dataError = dismissBannerMessage as DismissBannerMessageError;
    if (dataError) {
      return dataError.message;
    } else if (fetchError) {
      return fetchError.message;
    }
    return null;
  }, [dismissBannerMessage, fetchError]);

  return { fetching, error, deleteBanner };
};

export default useDeleteSystemBanner;
